module.exports = __webpack_public_path__ + "img/1.b25a4786.png";